import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { isEmpty, startCase } from 'lodash'
import Pagination from 'pages/Pagination'
import OImage from 'components/reusable/OImage'
import homeImg from '../../assets/images/home.png'
import pathObj from 'utils/apiPath'
import { apiGet } from 'utils/apiFetch'
import { NavLink } from 'react-router-dom'
import { TAB_APPOINTMENT_DETAIL } from 'pages/users/CustomerViewPage'
import helper from 'utils/helpers'

const OAppointments = ({ userId, agentId, companyId }) => {
  const { t } = useTranslation()
  const [appointmentData, setAppointmentData] = useState([])
  const [page, setPage] = useState(1)

  const [pageSize] = useState(10)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const handleTabClick = async () => {
    const payload = {
      page,
      pageSize
    }
    let path
    if (companyId) {
      path = pathObj.appointmentCompanyList
    } else if (userId) {
      path = pathObj.appointmentUserList
    } else if (agentId) {
      path = pathObj.appointmentAgentList
    }
    if (userId) {
      payload.userId = userId
    }
    if (agentId) {
      payload.agentId = agentId
    }
    if (companyId) {
      payload.companyId = companyId
    }

    const result = await apiGet(path, payload)
    if (result?.data?.success) {
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAppointmentData(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    }
  }

  useEffect(() => {
    handleTabClick()
  }, [page])

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  return (
    <>
      <div className='p-3'>
        <div className='overflow-x-auto relative 
 border'>
          <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
            <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6'>
                  #
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('Photo')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_PROPERTY_TITLE')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_PROPERTY_TYPE')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_PROPERTY_ID')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_PROPERTY_CATEGORY_NAME')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_AGENT_NAME')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_CLIENT_NAME')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_APPOINTMENT_DATE')}
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('O_APPOINTMENT_TIME')}
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('O_STATUS')}
                </th>

                <th scope='col' className='py-3 px-6 text-center'>
                  {t('O_ACTION')}
                </th>
              </tr>
            </thead>
            <tbody>
              {appointmentData &&
                appointmentData?.map((item, i) => (
                  <tr
                    key={i}
                    className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                  >
                    <th
                      scope='row'
                      className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                    >
                      {i + 1 + 10 * (paginationObj?.page - 1)}
                    </th>
                    <td className='py-3 px-6 border-r text-center'>
                      <figure className='inline-block overflow-hidden rounded-full border-2 mb-0'>
                        <OImage
                          src={
                            item?.property?.photos?.length > 0
                              ? item?.property?.photos[0]
                              : homeImg
                          }
                          // src={item?.property?.photos[0] ? item?.property?.photos[0] : homeImg}
                          className='w-10 h-10'
                        />
                      </figure>
                    </td>
                    <td className='py-2 px-2 border-r'>
                      {startCase(item?.property?.title)}
                    </td>
                    <td className='py-2 px-2 border-r'>
                      {startCase(item?.propertyType?.name)}
                    </td>
                    <td className='py-2 px-2 border-r'>
                      {item?.property?.propertyId}
                    </td>
                    <td className='py-2 px-2 border-r'>
                      {startCase(item?.propertyCategory?.name)}
                    </td>
                    <td className='py-2 px-2 border-r '>
                      {item?.agent?.firstName
                        ? startCase(item?.agent?.firstName) +
                          ' ' +
                          startCase(item?.agent?.lastName)
                        : 'N/A'}
                    </td>
                    <td className='py-2 px-2 border-r'>
                      {item?.user?.firstName
                        ? startCase(item?.user?.firstName) +
                          ' ' +
                          startCase(item?.user?.lastName)
                        : 'N/A'}
                    </td>
                    <td className='py-2 px-2 border-r'>
                      {dayjs(item?.appointmentDateTime).format('DD MMMM YYYY')}
                    </td>

                    <td className='py-2 px-2 border-r '>
                      {helper.dateFormatTimeAppointment(
                        item?.appointmentDateTime,
                        'hh:mm A'
                      )}
                    </td>

                    <td className='py-2 px-2 border-r '>
                      {startCase(item?.isApprovedStatus)}
                    </td>
                    <td className='py-4 px-6 border-l'>
                      <div className=''>
                        <ul className='flex justify-center'>
                          <>
                            <NavLink
                              to={`/properties/view/${item?.propertyId}`}
                              state={{
                                item,
                                view: 'appointmentView',
                                tab: TAB_APPOINTMENT_DETAIL,
                                propertyId: item?.propertyId
                              }}
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer'
                            >
                              {t('O_VIEW_PROPERTY_DETAILS')}
                            </NavLink>
                          </>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              {isEmpty(appointmentData) && (
                <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-4 px-6' colSpan={12}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {paginationObj?.totalItems !== 0 && (
        <Pagination
          handlePageClick={handlePageClick}
          options={paginationObj}
          page={page}
        />
      )}
    </>
  )
}

export default OAppointments
